import React, { useState } from "react";
import { getToken } from "../../../../utils/token";
import { toast } from "react-toastify";
import { useRevalidator } from "react-router-dom";
import Spinner from "../../../../components/spinners/Spinner";
import instance from "../../../../axios/instance";
import PrimaryAddButton from "../../../../components/buttons/PrimaryAddButton";
import InputMask from "react-input-mask";
import NormalInputField from "../../../../components/inputs/NormalInputField";
import NormalSelectInputField from "../../../../components/inputs/NormalSelectInputField";

export const OnboardingSetup = ({ facility }) => {
  const [loading, setLoading] = useState(false);
  const [noAccount, setNoAccount] = useState(!facility.account_number);
  const [formData, setFormData] = useState({
    name: facility.name || "",
    account_type: "",
    bank_name: "",
    bank_address: "",
    routing_number: "",
    account_number: "",
  });
  const revalidator = useRevalidator();

  const btnDisabled =
    !formData.name ||
    !formData.account_type ||
    !formData.account_number ||
    !formData.bank_name ||
    !formData.routing_number ||
    !formData.bank_address;

  const handleCreateAccount = async () => {
    const token = getToken();
    try {
      setLoading(true);
      await instance.post("/doctor/connect/new", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      revalidator.revalidate();
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.error(
        error.response ? error.response.data.message : "An error occurred"
      );
    }
  };

  return (
    <div className="w-full px-7 py-5 bg-bg">
      <div className="w-full px-7 py-5 bg-bg">
        {noAccount ? (
          <>
            <p className="font-bold text-2xl mb-2">
              Receive your earnings directly to your bank account
            </p>
            <p>
              To get started with receiving your earnings directly to your
              account, click the button below and fill out the onboarding form
              that follows
            </p>
            <button
              className="bg-primary text-white px-5 py-2 rounded-md mt-5 flex items-center justify-center h-[40px] min-w-[140px] disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={() => setNoAccount(false)}
              disabled={loading}
            >
              {loading ? <Spinner color="white" /> : "Get Started"}
            </button>
          </>
        ) : (
          <>
            <p className="font-bold text-2xl mb-2">Earnings Setup</p>
            <p>
              Fill in the required fields to complete your earnings setup and
              receive payouts directly to your bank account
            </p>
            <div className="bg-white my-5 px-5 py-7 rounded-md border">
              <div className="grid grid-cols-2 gap-x-5 gap-y-7">
                <NormalInputField
                  title="Business/Individual Name"
                  type="text"
                  placeholder="Enter business name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, name: e.target.value }))
                  }
                  required={true}
                />
                <NormalSelectInputField
                  values={[
                    { label: "Current", value: "current" },
                    { label: "Savings", value: "savings" },
                  ]}
                  title="Account Type"
                  value={formData.account_type}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      account_type: e.target.value,
                    }))
                  }
                  required={true}
                />
                <NormalInputField
                  title="Bank Name"
                  type="text"
                  placeholder="Enter bank name"
                  value={formData.bank_name}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      bank_name: e.target.value,
                    }))
                  }
                  required={true}
                />
                <NormalInputField
                  title="Bank Address"
                  type="text"
                  placeholder="Enter bank address"
                  value={formData.bank_address}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      bank_address: e.target.value,
                    }))
                  }
                  required={true}
                />
                <InputMask
                  mask="999999999"
                  maskChar=""
                  value={formData.routing_number}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      routing_number: e.target.value,
                    }))
                  }
                >
                  {(inputProps) => (
                    <NormalInputField
                      title="Routing Number"
                      type="text"
                      placeholder="Enter routing number"
                      name="routing_number"
                      {...inputProps}
                      required={true}
                    />
                  )}
                </InputMask>
                <InputMask
                  mask="999999999999"
                  maskChar=""
                  value={formData.account_number}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      account_number: e.target.value,
                    }))
                  }
                >
                  {(inputProps) => (
                    <NormalInputField
                      title="Account Number"
                      type="text"
                      placeholder="Enter account number"
                      name="account_number"
                      {...inputProps}
                      required={true}
                    />
                  )}
                </InputMask>
              </div>
              <div className="mt-5">
                <PrimaryAddButton
                  title="Complete Setup"
                  type="button"
                  disabled={loading || btnDisabled}
                  isLoading={loading}
                  onClick={handleCreateAccount}
                  color="white"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
